import React from 'react';
import { motion } from 'framer-motion';
import { FilePage } from './FilePage';
import { CtaButton } from './CtaButton';
import { offerItems } from '../data/offer';
import { PRIMARY_CTA_ID } from '../data/checkout';
export function PriceFile() {
  return <FilePage id="precio" number="05" label="Precio y Valor" data-id="element-140" data-mp="1fx76v6w8hctq">
      <div className="grid gap-5 sm:gap-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14" data-id="element-141" data-mp="1jxr1o3tc44cp">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.6
      }} className="rounded-xl border border-white/[0.08] bg-panel p-5 sm:p-6" data-id="element-142" data-mp="27m0issfls3xi">
          <p className="font-mono text-[9.5px] uppercase tracking-[0.16em] text-white/35" data-id="element-143" data-mp="22v20xoeyuxs5">
            Hoja de valoración · Anexo 05-A
          </p>
          <ul className="mt-4 divide-y divide-white/[0.06] sm:mt-5" data-id="element-144" data-mp="2qjv0rvyplps1">
            {offerItems.map(item => <li key={item.id} className="flex items-baseline justify-between gap-4 py-2.5" data-id="element-145" data-mp="2vdz7qf7z5xt4">
                <span className="text-[13.5px] text-ash" data-id="element-146" data-mp="22tog3sji8jh4">{item.title}</span>
                <span className={`font-mono text-[12.5px] font-bold ${item.isFree ? 'text-[#8be3ff]' : 'text-gold'}`} data-id="element-147" data-mp="2hi2hdz19vzvk">
                  {item.isFree ? 'GRATIS' : item.value}
                </span>
              </li>)}
          </ul>
          <div className="mt-4 flex items-baseline justify-between border-t border-gold/25 pt-4" data-id="element-148" data-mp="2mhoveaoxdk5f">
            <span className="font-mono text-[11px] uppercase tracking-[0.16em] text-bone" data-id="element-149" data-mp="30hghkypli6ui">
              Valor real total
            </span>
            <span className="font-display text-2xl font-extrabold text-bone" data-id="element-150" data-mp="2vid9f5ebjkib">
              $505.00
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 28,
        scale: 0.98
      }} whileInView={{
        opacity: 1,
        y: 0,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.75,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative flex flex-col items-center justify-center rounded-xl border border-gold/30 bg-[radial-gradient(ellipse_at_50%_0%,rgba(212,175,55,0.16),transparent_65%),#0e0e12] px-5 py-8 text-center sm:px-6 sm:py-10" data-id="element-151" data-mp="114cdasa5lblx">
          <span className="absolute -top-2.5 left-6 rounded border border-gold/40 bg-ink px-2 py-0.5 font-mono text-[8.5px] uppercase tracking-[0.16em] text-gold" data-id="element-152" data-mp="3k56b9z3oo3ea">
            Resolución del caso
          </span>
          <p className="max-w-[24rem] text-[13.5px] leading-relaxed text-ash" data-id="element-153" data-mp="3tu7s1ri1yotb">
            Venderlo por $97 sería una ganga. Pero queremos llenar nuestra
            comunidad de Skool con los mejores creadores del mundo hispano.
          </p>
          <span className="mt-5 text-lg text-white/35 line-through sm:mt-7" data-id="element-154" data-mp="6ruvkll4zr2f">
            $47
          </span>
          <span className="animate-gold-glow font-display text-[3rem] font-black leading-none text-gold sm:text-[4.2rem]" data-id="element-155" data-mp="bn0f5dr2gtnc">
            $11.99
          </span>
          <span className="mt-2.5 font-mono text-[10px] uppercase tracking-[0.18em] text-ash sm:mt-3" data-id="element-156" data-mp="gsx7416e6ow5">
            Pago único · Acceso inmediato
          </span>
          <p className="mt-4 max-w-[24rem] text-[12.5px] leading-relaxed text-white/45 sm:mt-5" data-id="element-157" data-mp="7ta5be9r3h2k">
            Menos de lo que cuesta una suscripción básica de Netflix, pero con el
            potencial de construir un negocio de 6 cifras.
          </p>
          <div id={PRIMARY_CTA_ID} className="mt-6 w-full scroll-mt-[140px] sm:mt-8 sm:w-auto" data-id="element-158" data-mp="zlraryykeul2">
            <CtaButton className="w-full sm:w-auto" subLabel="Pago único. Acceso inmediato a todos los bonos." data-id="element-159" data-mp="urdc9nolw7c6">
              Sí, quiero disrupción visual ahora — acceso por $11.99
            </CtaButton>
          </div>
        </motion.div>
      </div>
    </FilePage>;
}